import { z } from 'zod';

export const declineSchema = z.object({
  description: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type PrivateCompanyLeadsFunnelDeclineValidationSchema = z.infer<typeof declineSchema>